const installationInstructions = {
  intro: {
    currentStep: 'intro',
    includeInstallationSteps: false,
    includePairingProcess: true,
    isLastPage: false,
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: 'Congratulations on getting a PowerTech Plug!',
    resource: require('@/assets/device-models/PTP-01/pep-smart-plug.png'),
    haloDeviceResource: require('@/assets/device-models/PTP-01/plug_halo.png'),
    resourceType: 'image',
    secondaryText: "To get your device up and running we'll guide you through the ",
    continueButtonText: 'Get Started',
  },
  letsGetStarted: {
    additionalSecondaryTextClasses: 'section-seperator',
    continueButtonText: 'Get Started',
    currentStep: 'letsGetStarted',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    prevStepName: 'installationIntro', // installationIntro doesn't have a prop of :step so omit `prevStep`
    primaryText: "Let's Get Started",
    secondaryText: 'To pair your PowerTech Plug, you need the following:',
    steps: [
      {
        icon: require('@/assets/images/wifi-icon.png'),
        description: 'Strong Wi-Fi Network & Password'
      },
      {
        icon: require('@/assets/images/power-outlet-icon.png'),
        description: 'Power Source'
      }
    ],
    title: 'Pair Plug'
  },
  pairingModeReset: {
    prevStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/PTP-01/pep-smart-plug.png'),
    primaryText: 'Putting the PowerTech Plug into Pairing Mode',
    secondaryText: 'If the LED is not double blinking green, the plug is not in pairing mode. To manually put the plug into pairing mode:',
    steps: [
      {
        title: 'Unplug the PowerTech plug.',
        stepNumber: 1
      },
      {
        title: 'Depress the button and plug in',
        description: 'Again, release the button after 3 seconds.',
        stepNumber: 2
      },
      {
        title: 'After the PowerTech plug restarts, ',
        description: 'The LED on the front of the plug will turn to double blinking green.',
        stepNumber: 3
      },
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    title: 'Re-Pair Plug'
  }
};

export default installationInstructions;
